import {
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  Stepper,
  Flex,
  Progress,
  Text,
} from "@chakra-ui/react";

interface StepperProps {
  steps: { title: string }[];
  activeStep: number;
  progressPercent: number;
}

export const CustomStepper = ({
  steps,
  activeStep,
  progressPercent,
}: StepperProps) => {
  return (
    <Flex
      justify={"center"}
      direction={"column"}
      align={"center"}
      width="100%"
      position={"relative"}
    >
      <Stepper
        colorScheme="brand.primary"
        size="sm"
        index={activeStep}
        gap="0"
        width={"100%"}
      >
        {steps.map((_, index) => (
          <Step key={index}>
            <Flex direction={"column"}>
              <StepIndicator bg="white" zIndex={2}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={
                    <Flex
                      width={"100%"}
                      height={"100%"}
                      rounded={"full"}
                      justify={"center"}
                      align={"center"}
                      bg={"background.white"}
                    >
                      <Flex
                        width={"30%"}
                        height={"30%"}
                        bg={"#94A3B8"}
                        rounded={"full"}
                      ></Flex>
                    </Flex>
                  }
                  active={
                    <Flex
                      width={"90%"}
                      height={"90%"}
                      bg={"brand.primary.DEFAULT"}
                      rounded={"full"}
                      justify={"center"}
                      align={"center"}
                    >
                      <Flex
                        width={"28%"}
                        height={"28%"}
                        bg={"text.white"}
                        rounded={"full"}
                      ></Flex>
                    </Flex>
                  }
                />
              </StepIndicator>
            </Flex>
          </Step>
        ))}
      </Stepper>
      <Progress
        colorScheme="brand.primary"
        value={progressPercent}
        position="absolute"
        height="3px"
        width="full"
        top="10px"
      />
      <Flex pos={"relative"} width={"110%"} justify={"space-between"} mt={2}>
        {steps.map((step, index) => (
          <Text
            key={index}
            color={
              activeStep === index ? "brand.primary.DEFAULT" : "text.secondary"
            }
            textDecor={activeStep === index ? "underline" : "none"}
            fontSize={"sm"}
            fontFamily={"primary"}
            fontWeight={"normal"}
            mr={index === 1 ? 6 : ""}
          >
            {step.title}
          </Text>
        ))}
      </Flex>
    </Flex>
  );
};
